import React, { useState } from 'react';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../utils/globals';
import { useMediaQuery } from '../../../utils/hooks/useMediaQuery';
import { Body } from '../../UI/Elements';
import { Image, Video } from '../../UI/Media';
import { Disclosure } from '../../UI/Navigation/Disclosure/disclosure';

export const NoozProtect = ({ label, details, video }) => {
  const [activeDetail, setActiveDetail] = useState(0);
  const isWindowSmallSize = useMediaQuery('lg');

  return (
    <div className='bg-black overflow-hidden w-screen text-white flex flex-col md:flex-row md:justify-center md:py-20 relative'>
      {/* Mobile Image */}
      {details.items.map((item, index) => (
        <div
          className={`${
            index === activeDetail ? 'block' : 'hidden'
          } md:hidden h-full w-full`}>
          <Image
            {...formatContentfulComponentProps(details.items[activeDetail])
              .image}
            isNative
            objectFit='cover'
            width='100%'
            height='100%'
          />
        </div>
      ))}
      {/* Desktop & Tablet Image */}
      {details.items.map((item, index) => (
        <div
          className={`${
            index === activeDetail ? 'opacity-1' : 'opacity-0'
          } hidden absolute md:flex transform transition duration-1000 justify-end w-screen/2 top-0 right-0`}>
          <Image
            {...formatContentfulComponentProps(item).image}
            isNative
            width='100%'
            height='100%'
          />
        </div>
      ))}
      <div className='relative main-wrapper w-full border-t border-white'>
        <div className='w-full md:w-2/3 mt-8'>
          <Label
            {...label}
            size={isWindowSmallSize ? '5xl' : '7xl'}
          />
        </div>
        {/* Details Disclosures */}
        <div className='w-full md:pb-20 md:pl-20 lg:w-1/2 mt-16'>
          {details.items.map((detail, index) => {
            const d = formatContentfulComponentProps(detail);
            const buttonLabel = `${index + 1}. ${d.label?.text}`;

            const chevronIcon = (
              <Icon
                iconKey='HiChevronDown'
                size='2xl'
                color={{ classname: 'white' }}
              />
            );

            return (
              <div className='my-4'>
                <Disclosure
                  onClick={() => setActiveDetail(index)}
                  defaultOpen={index === 0}
                  isOpen={index === activeDetail}
                  chevronIcon={chevronIcon}
                  button={
                    <Label
                      {...d.label}
                      text={buttonLabel}
                      size='3xl'
                    />
                  }>
                  <div className='py-7'>
                    <Body {...d.body} />
                  </div>
                </Disclosure>
              </div>
            );
          })}
        </div>
        {/* Media video */}
        <div className='flex justify-center w-full'>
          <div className='w-full py-10 lg:py-0 lg:w-2/3 h-96'>
            <Video {...video} />
          </div>
        </div>
      </div>
    </div>
  );
};
